import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["frame"];
  static values = {
    url: String,
    param: String,
    scope: { type: String, default: "form" },
  };

  load() {
    const dialog = this.frameTarget.closest("dialog");
    if (dialog && !dialog.open) return;

    const query = new URLSearchParams(
      this.selectedValues.map((value) => [this.paramValue, value]),
    );
    const url = `${this.urlValue}?${query}`;

    this.frameTarget.src === url
      ? this.frameTarget.reload()
      : (this.frameTarget.src = url);
  }

  get selectedValues() {
    const scope = this.element.closest(this.scopeValue);

    return [
      ...scope.querySelectorAll(`input[name="${this.paramValue}"]:checked`),
    ].map((checkbox) => checkbox.value);
  }
}
